import { List, ListItem } from '@mui/material'
import React from 'react'
import styles from './CartItems.module.scss'
import { CartInterface, CartItemGiftInterface } from '../../../interfaces/CartInterface'
import CartItem from '../CartItem'

interface Props {
  cart: CartInterface
  gifts: CartItemGiftInterface[] | null
  className?: string
  readOnly?: boolean
  compactLayout?: boolean
}

const CartItems: React.FC<Props> = (props: Props) => {
  const [updatingCart, setUpdatingCart] = React.useState<boolean>(false)

  const handleUpdateStarted = () => {
    setUpdatingCart(true)
  }

  const handleUpdateCompleted = () => {
    setUpdatingCart(false)
  }

  return (
    <List
      classes={{
        root: props.className,
      }}
    >
      {props.cart.items.map(item => (
        <ListItem
          key={item.id}
          classes={{
            root: styles['item'],
          }}
        >
          <CartItem
            item={item}
            key={item.id}
            currencyCode={props.cart.currency}
            gifts={props.gifts}
            readOnly={props.readOnly}
            isCartUpdating={updatingCart}
            compactLayout={props.compactLayout}
            onUpdateCompleted={handleUpdateCompleted}
            onUpdateStarted={handleUpdateStarted}
          />
        </ListItem>
      ))}
    </List>
  )
}

export default CartItems
